<ng-container *ngFor="let item of delayObj">
    <snl-pills *ngIf="item.min <= delayVal.approx && item.max > delayVal.approx"   [type]="'outline'" [layout]="item.cls">{{delayVal.val+' '+delayVal.type}}</snl-pills>
</ng-container>

